import BossModel from "@/models/BossModel";

export default class RevenueGroup extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'revenue-group';

    /**
     *
     * @type {string}
     */
    static entity = 'revenueGroups';

    static fields() {
		return {
			id: this.attr(null),
			name: this.attr(null),
			sort_order: this.attr(null),
		}
	}

    /**
     *
     * @returns {*}
     */
    static fetchAllForSelect() {
        return this.api()
            .limit(0)
            .get(true);
    }
}
